import React, {useContext, useEffect, useState} from 'react';
import './DeliveryAddress.less';
import {Button} from "elements/button/Button";
import {Input} from "elements/input/Input";
import {DrawerPopup} from "dialog-layout/drawer-popup/DrawerPopup.tsx";
import {PlaceAutocomplete} from "compositions/place-autocomplete/PlaceAutocomplete";
import {AutocompleteList} from "compositions/autocomplete-list/AutocompleteList";
import {Error} from "elements/error/Error";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";
import {Success} from "elements/success/Success";

export const DELIVERY_ADDRESS_POPUP = 'DELIVERY_ADDRESS_POPUP';
export const CART_DELIVERY_ADDRESS_POPUP = 'CART_DELIVERY_ADDRESS_POPUP';

let placesService = null;
let sessionToken = null;

export const DeliveryAddress = ({
                                    isRequestInProgress = false,
                                    defaultAddressValue = '',
                                    defaultPredictionIdValue = null,
                                    defaultZipValue = '',
                                    error,
                                    onOverlayClick,
                                    onCancelClick,
                                    onDoneClick,
                                }) => {
    const [predictionId, setPredictionId] = useState(defaultPredictionIdValue);
    const [address, setAddress] = useState(defaultAddressValue);
    const [location, setLocation] = useState(null);
    const [zip, setZip] = useState(defaultZipValue);
    const [isCheckClicked, setIsCheckClicked] = useState(false);

    //TODO implement delivery flow for initial popup too

    const translations = useContext(TranslationsContext);

    useEffect(() => {
        if (!(window.google && window.google.maps && window.google.maps.places)) return;

        if (!!placesService) return;

        const dummy = document.createElement('span');
        placesService = new window.google.maps.places.PlacesService(dummy);
    });

    useEffect(() => {
        if (!(window.google && window.google.maps && window.google.maps.places)) return;

        if (!!sessionToken) return;

        sessionToken = new google.maps.places.AutocompleteSessionToken();
    });

    return <DrawerPopup
        title={getSafeTranslation('DeliveryAddressPopup.title', translations)}
        onOverlayClick={onOverlayClick}
        leftControl={<Button isText onClick={onCancelClick}>
            {getSafeTranslation('DeliveryAddressPopup.cancelButtonCaption', translations)}
        </Button>}
        rightControl={<Button
            isAutoWidth
            onClick={() => onDoneClick(address, zip, location, predictionId, false)}
            isDisabled={!predictionId}
        >
            {getSafeTranslation('DeliveryAddressPopup.doneButtonCaption', translations)}
        </Button>}
    >
        <div className="delivery-address">
            <div className="delivery-address__container">
                <div className="delivery-address__address-input">
                    <Input value={address} onChange={address => {
                        setPredictionId(null);
                        setAddress(address);
                    }} focusOnMount/>
                </div>
            </div>
            {
                !predictionId && (
                    <div className="delivery-address__autocomplete-options">
                        <PlaceAutocomplete
                            query={address}
                            sessionToken={sessionToken}
                        >
                            {
                                (predictions) => {
                                    return <AutocompleteList
                                        options={predictions.map(prediction => ({
                                            id: prediction.place_id,
                                            name: prediction.description
                                        }))}
                                        onOptionClick={clickedId => {
                                            const clickedPrediction = predictions.find(prediction => prediction.place_id === clickedId);
                                            setAddress(clickedPrediction.description);
                                            setPredictionId(clickedPrediction.place_id);
                                            placesService && placesService.getDetails({
                                                placeId: clickedPrediction.place_id,
                                                fields: ['address_components', 'geometry'],
                                                sessionToken
                                            }, (place, status) => {
                                                if (status == window.google.maps.places.PlacesServiceStatus.OK) {
                                                    const zipCode = place.address_components.find(addressComponent => addressComponent.types.includes('postal_code'));
                                                    setZip(zipCode?.long_name);
                                                    setLocation({
                                                        latitude: place.geometry.location.lat(),
                                                        longitude: place.geometry.location.lng()
                                                    });
                                                    onDoneClick(
                                                        clickedPrediction.description,
                                                        zipCode?.long_name,
                                                        {
                                                            latitude: place.geometry.location.lat(),
                                                            longitude: place.geometry.location.lng()
                                                        },
                                                        clickedPrediction.place_id,
                                                        true
                                                    );
                                                    setIsCheckClicked(true);
                                                } else {
                                                    setZip(null);
                                                }
                                            });
                                        }}
                                    />
                                }
                            }
                        </PlaceAutocomplete>
                    </div>
                )
            }
            {
                error && (<div className="delivery-address__error">
                    <Error text={error}/>
                </div>)
            }

            {
                (isCheckClicked && !error && !isRequestInProgress) && (<div className="delivery-address__success">
                    <Success text={getSafeTranslation('Success.ableToDeliver', translations)}/>
                </div>)
            }
        </div>
    </DrawerPopup>
}
